let budget_sequence_ref = null;
let override_sequence_ref = null;
let irregular_sequence_ref = null;

export function initialize_finance_sequences(sequences) {
  budget_sequence_ref = sequences.budget;
  override_sequence_ref = sequences.override;
  irregular_sequence_ref = sequences.irregular;
}

export function next_budget_row(is_edit, index, budget_rows) {
  if (is_edit) {
    const existing_budget_row = Reflect.get(budget_rows, index);
    return existing_budget_row;
  }
  budget_sequence_ref += 1;
  const new_budget_row = { id: `budget_${budget_sequence_ref}` };
  return new_budget_row;
}

function next_override_row() {
  override_sequence_ref += 1;
  const override_row = { id: `override_${override_sequence_ref}` };
  return override_row;
}

export function next_irregular_row(is_edit, index, irregular_rows) {
  if (is_edit) {
    const existing_irregular_row = Reflect.get(irregular_rows, index);
    return existing_irregular_row;
  }
  irregular_sequence_ref += 1;
  const irregular_row = { id: `irregular_${irregular_sequence_ref}` };
  return irregular_row;
}

function finance_row_value(row, key, fallback_value) {
  const row_value = Reflect.get(row || {}, key);
  return row_value || fallback_value;
}

export function build_budget_modal_form(row) {
  const budget_modal_form = {
    line: finance_row_value(row, 'line', ''),
    budget: finance_row_value(row, 'budget_raw', ''),
    committed: finance_row_value(row, 'committed_raw', ''),
    status: finance_row_value(row, 'status_value', 'Within budget')
  };
  return budget_modal_form;
}

export function build_override_modal_form(row) {
  const override_modal_form = {
    invoice: finance_row_value(row, 'invoice', ''),
    reason: finance_row_value(row, 'reason', ''),
    authorised_by: finance_row_value(row, 'authorised_by', ''),
    date: finance_row_value(row, 'date', ''),
    status: finance_row_value(row, 'status_value', 'Approved')
  };
  return override_modal_form;
}

export function build_irregular_modal_form(row) {
  const irregular_modal_form = {
    title: finance_row_value(row, 'title', ''),
    type: finance_row_value(row, 'type', 'Irregular'),
    invoice: finance_row_value(row, 'invoice', ''),
    amount: finance_row_value(row, 'amount_raw', ''),
    detail: finance_row_value(row, 'detail', ''),
    status: finance_row_value(row, 'status_value', 'Open')
  };
  return irregular_modal_form;
}

export function override_row_for_submit(vm) {
  if (vm.override_modal_mode === 'edit' && vm.override_modal_index !== null) {
    const existing_row = Reflect.get(vm.override_rows, vm.override_modal_index);
    return existing_row;
  }
  return next_override_row();
}
